/* Rivox motion system — auto-tags key elements in rvx-* sections for
   scroll-reveal with sibling stagger. Safe by default: without JS the
   hidden state never applies (gated on html.rvx-motion). */
(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if (!("IntersectionObserver" in window)) return;

  var SELECTORS = [
    '[class*="rvx-"][class*="__eyebrow"]',
    '[class*="rvx-"][class*="__headline"]',
    '.rvx-pp3__card',
    '.rvx-pp4__tile',
    '.rvx-pair__media',
    '.rvx-pair__content',
  ];

  function init() {
    var els = document.querySelectorAll(SELECTORS.join(","));
    if (!els.length) return;
    document.documentElement.classList.add("rvx-motion");

    /* stagger siblings that share a parent */
    var groups = new Map();
    els.forEach(function (el) {
      el.setAttribute("data-rvx-reveal", "");
      var parent = el.parentElement;
      var idx = groups.get(parent) || 0;
      el.style.setProperty("--rvx-d", Math.min(idx * 90, 450) + "ms");
      groups.set(parent, idx + 1);
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("rvx-in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );
    els.forEach(function (el) {
      /* skip elements already in view at load (above the fold) */
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) {
        el.classList.add("rvx-in");
      } else {
        io.observe(el);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
